import { action, computed, observable } from 'mobx';

import {
    addToCollection,
    removeFromCollection
} from '~api/CollectionsAPI/handlers/CollectionsHandlers';
import { CollectionRepository } from '~repositories/CollectionRepository/CollectionRepository';
import { diContainer } from '~setup/diContainer';
import { serviceNames } from '~setup/CartService';
import RemoveItemUseCase from '~use-cases/RemoveItemUseCase';

export interface ICollectionButtonControllerProps {
    collectionName: string;
    sku: string;
}

export class CollectionButtonController {
    private _sku: string;
    private _collectionName: string;

    @observable private _isLoading: boolean = false;
    @observable private _collectionRepository: CollectionRepository = diContainer.get(
        serviceNames.collectionRepository
    );

    constructor({ collectionName, sku }: ICollectionButtonControllerProps) {
        this._sku = sku;
        this._collectionName = collectionName;
    }

    @action public addItem = async () => {
        this._isLoading = true;
        await addToCollection(this._collectionName, this._sku);

        this._collectionRepository.updateCollectionByName(this._collectionName);
        new RemoveItemUseCase({ skus: [this._sku?.toString()] }).execute();

        this._isLoading = false;
    };

    @action public removeItem = async () => {
        this._isLoading = true;
        await removeFromCollection(this._collectionName, this._sku);
        await this._collectionRepository.updateCollectionByName(this._collectionName);
        this._isLoading = false;
    };

    @action public isInCollection = () => {
        const collection = this._collectionRepository.getCollection(this._collectionName);

        return !!collection?.skus?.find(({ path }) => path.includes(this._sku));
    };

    @computed public get isLoading() {
        return this._isLoading || this._collectionRepository.isLoading;
    }
}
